// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"25fb0958","669":"a62dd490","845":"9c14c535"}[chunkId] + ".chunk.js";
};